<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-circle-check"></i>
    {{ texts.acceptedPrefix[language] }}
    @if (context != 'candidate') {
    @if (activity.Candidate) { <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> } @else { {{ texts.unknownCandidate[language] }} }
    }
    {{ texts.acceptedSuffix[language] }}
</sc-activity-list-item>
